import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTopics,
  getTopicError,
  getTopics,
  getTopicStatus,
} from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import UpperSection from "../common/UpperSection";
import TopicList from "./TopicList";

const AdminSubject = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const topics = useSelector(getTopics);
  const status = useSelector(getTopicStatus);
  const error = useSelector(getTopicError);

  useEffect(() => {
    if (!topics) {
      dispatch(fetchTopics());
    }
  }, [dispatch, topics]);

  const filteredTopics = topics?.filter((entry) => {
    return entry?.topicName?.toLowerCase().includes(searchQuery);
  });

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type={status} message={error} /> : null}

      {/* Upper Section */}
      <UpperSection
        title="Topics"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <TopicList topics={filteredTopics} />
    </section>
  );
};

export default AdminSubject;
